import { useMember, useSession } from 'components/Providers'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import * as action from 'store/member/attendance-report'
import { useParams } from 'react-router-dom'
import Attendance from 'components/Attendance'
import NotFound from 'components/NotFound'
import Skeleton from './Skeleton'
import { useBasePath } from 'components/Providers'
import MarkingPeriodField from 'components/MarkingPeriodField'
import { Box } from '@mui/material'
import { getMarkingPeriods } from 'store/lookup'

export default function Index() {
  const member = useMember()
  const dispatch = useDispatch()
  const { memberId, employmentType } = useParams()
  const [notFound, setNotFound] = useState(false)
  const basePath = useBasePath()
  const { academicYear } = useSession();
  const { currentMarkingPeriodId } = useSelector(state => state.lookup);

  useEffect(() => {
    if (!currentMarkingPeriodId) {
      dispatch(getMarkingPeriods({ id: academicYear?.id }));
    }
  }, [dispatch, academicYear]);

    useEffect(() => {
      if (currentMarkingPeriodId) {
        dispatch(action.retrieve({ type: employmentType, memberId, markingPeriodId: currentMarkingPeriodId })).then(res => {
          res.error && setNotFound(true)
        })
      }
    }, [dispatch, memberId, employmentType, currentMarkingPeriodId])

    const attendanceReports = useSelector(state => state.member.list.find(item => item.id === member.id).attendanceReport)

    let absenceRate =
      (attendanceReports?.daily?.absent * 100) /
      (attendanceReports?.daily?.absent + attendanceReports?.daily?.tardy + attendanceReports?.daily?.present)

    absenceRate = isNaN(absenceRate) || !isFinite(absenceRate) ? '-' : absenceRate

    if (notFound) return <NotFound basePath={`${basePath}/attendance`} />

    return (
      <Box>
        <MarkingPeriodField
          label='Marking Period'
          academicYearId={academicYear?.id}
          includeAll={true}
          width="50%"
          size={"small"}
        />
        {!attendanceReports || !currentMarkingPeriodId ? (
          <Skeleton />
        ) : (
          <Attendance absenceRate={absenceRate} attendanceReports={attendanceReports} />
        )}
      </Box>
    )

  }
